import { render } from "./CheckoutRegisterPassword.vue?vue&type=template&id=c40948ca&ts=true"
import script from "./CheckoutRegisterPassword.vue?vue&type=script&lang=ts"
export * from "./CheckoutRegisterPassword.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__